import { useQuery } from "@tanstack/react-query";
import { courseStudentsApi } from "api/courseStudentsApi";
import { QUERIES_KEYS } from "queries";

export const useStudentEndSurvey = (courseId: number, studentId: number) => {
  const { isLoading, data, isError } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_STUDENT_END_SURVEY(courseId, studentId),
    queryFn: () => courseStudentsApi.fetchEndSurvey(courseId, studentId),
    enabled: !!courseId && !!studentId,
    retry: false, // Don't retry on 404 (no survey filled)
  });

  return {
    isLoading,
    survey: data?.data,
    courseRating: data?.data?.courseRating,
    isError,
  };
};
